export default __webpack_public_path__ + "static/3_orange-38fe7adcff9dfe2ef6a2dde11516fb52.svg";